/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAthenaTablesForOrganizationQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['String'];
  creditFacilityIds?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  tablePrefixes?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type GetAthenaTablesForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaTables: Array<(
    { __typename?: 'AthenaTable' }
    & Pick<Types.AthenaTableGQLType, 'tableName'>
    & { properties: Array<(
      { __typename?: 'AthenaTableProperty' }
      & Pick<Types.AthenaTablePropertyGQLType, 'name' | 'type'>
    )> }
  )> }
);

export type GetAthenaQueryResponseByRawQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['String'];
  query: Types.Scalars['String'];
  bindings: Array<Types.Scalars['String']> | Types.Scalars['String'];
  variables: Array<Types.QueryVariableGQLType> | Types.QueryVariableGQLType;
}>;


export type GetAthenaQueryResponseByRawQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaQueryResponse: (
    { __typename?: 'AthenaQueryResponse' }
    & Pick<Types.AthenaQueryResponseGQLType, 'Items' | 'NextToken' | 'QueryExecutionId'>
  ) }
);

export type ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['String'];
  globalRecurringDateConfigsString: Types.Scalars['String'];
  globalRecurringDateConfigFields: Array<Types.Scalars['String']> | Types.Scalars['String'];
  supplementalVariables: Array<Types.QueryVariableGQLType> | Types.QueryVariableGQLType;
  variables: Array<Types.QueryVariableGQLType> | Types.QueryVariableGQLType;
  bindings: Array<Types.Scalars['String']> | Types.Scalars['String'];
  queryString: Types.Scalars['String'];
  queryName: Types.Scalars['String'];
}>;


export type ExecuteAthenaRecurringQueryByRawQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaRecurringQueryResponse: (
    { __typename?: 'AthenaRecurringQueryResponse' }
    & Pick<Types.AthenaRecurringQueryResponseGQLType, 'items' | 'errors'>
  ) }
);


export const GetAthenaTablesForOrganizationDocumentGQLType = gql`
    query GetAthenaTablesForOrganization($organizationId: String!, $creditFacilityIds: [String!], $tablePrefixes: [String!]) {
  athenaTables: getAthenaTablesForOrganization(
    organizationId: $organizationId
    creditFacilityIds: $creditFacilityIds
    tablePrefixes: $tablePrefixes
  ) {
    tableName
    properties {
      name
      type
    }
  }
}
    `;

/**
 * __useGetAthenaTablesForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAthenaTablesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaTablesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaTablesForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      tablePrefixes: // value for 'tablePrefixes'
 *   },
 * });
 */
export function useGetAthenaTablesForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>(GetAthenaTablesForOrganizationDocumentGQLType, options);
      }
export function useGetAthenaTablesForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>(GetAthenaTablesForOrganizationDocumentGQLType, options);
        }
export type GetAthenaTablesForOrganizationQueryHookResult = ReturnType<typeof useGetAthenaTablesForOrganizationQuery>;
export type GetAthenaTablesForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaTablesForOrganizationLazyQueryGQLType>;
export type GetAthenaTablesForOrganizationQueryResultGQLType = Apollo.QueryResult<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>;
export const GetAthenaQueryResponseByRawDocumentGQLType = gql`
    query GetAthenaQueryResponseByRaw($organizationId: String!, $query: String!, $bindings: [String!]!, $variables: [QueryVariable!]!) {
  athenaQueryResponse: getAthenaQueryResponseByRaw(
    organizationId: $organizationId
    query: $query
    bindings: $bindings
    variables: $variables
  ) {
    Items
    NextToken
    QueryExecutionId
  }
}
    `;

/**
 * __useGetAthenaQueryResponseByRawQuery__
 *
 * To run a query within a React component, call `useGetAthenaQueryResponseByRawQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaQueryResponseByRawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaQueryResponseByRawQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      bindings: // value for 'bindings'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useGetAthenaQueryResponseByRawQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>(GetAthenaQueryResponseByRawDocumentGQLType, options);
      }
export function useGetAthenaQueryResponseByRawLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>(GetAthenaQueryResponseByRawDocumentGQLType, options);
        }
export type GetAthenaQueryResponseByRawQueryHookResult = ReturnType<typeof useGetAthenaQueryResponseByRawQuery>;
export type GetAthenaQueryResponseByRawLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaQueryResponseByRawLazyQueryGQLType>;
export type GetAthenaQueryResponseByRawQueryResultGQLType = Apollo.QueryResult<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>;
export const ExecuteAthenaRecurringQueryByRawDocumentGQLType = gql`
    query ExecuteAthenaRecurringQueryByRaw($organizationId: String!, $globalRecurringDateConfigsString: String!, $globalRecurringDateConfigFields: [String!]!, $supplementalVariables: [QueryVariable!]!, $variables: [QueryVariable!]!, $bindings: [String!]!, $queryString: String!, $queryName: String!) {
  athenaRecurringQueryResponse: executeAthenaRecurringQueryByRaw(
    organizationId: $organizationId
    globalRecurringDateConfigsString: $globalRecurringDateConfigsString
    globalRecurringDateConfigFields: $globalRecurringDateConfigFields
    supplementalVariables: $supplementalVariables
    variables: $variables
    bindings: $bindings
    queryString: $queryString
    queryName: $queryName
  ) {
    items
    errors
  }
}
    `;

/**
 * __useExecuteAthenaRecurringQueryByRawQuery__
 *
 * To run a query within a React component, call `useExecuteAthenaRecurringQueryByRawQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteAthenaRecurringQueryByRawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteAthenaRecurringQueryByRawQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      globalRecurringDateConfigsString: // value for 'globalRecurringDateConfigsString'
 *      globalRecurringDateConfigFields: // value for 'globalRecurringDateConfigFields'
 *      supplementalVariables: // value for 'supplementalVariables'
 *      variables: // value for 'variables'
 *      bindings: // value for 'bindings'
 *      queryString: // value for 'queryString'
 *      queryName: // value for 'queryName'
 *   },
 * });
 */
export function useExecuteAthenaRecurringQueryByRawQuery(baseOptions: Apollo.QueryHookOptions<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>(ExecuteAthenaRecurringQueryByRawDocumentGQLType, options);
      }
export function useExecuteAthenaRecurringQueryByRawLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>(ExecuteAthenaRecurringQueryByRawDocumentGQLType, options);
        }
export type ExecuteAthenaRecurringQueryByRawQueryHookResult = ReturnType<typeof useExecuteAthenaRecurringQueryByRawQuery>;
export type ExecuteAthenaRecurringQueryByRawLazyQueryGQLTypeHookResult = ReturnType<typeof useExecuteAthenaRecurringQueryByRawLazyQueryGQLType>;
export type ExecuteAthenaRecurringQueryByRawQueryResultGQLType = Apollo.QueryResult<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>;